import React from 'react'
import StickerGraphic from './StickerGraphic'
import { STICKER_OPTION_BY_ID } from '../../constants/stickerOptions'

export default function PrintSticker({ sticker }) {
  const option = STICKER_OPTION_BY_ID[sticker.type]
  if (!option) return null

  const position = typeof sticker?.position === 'object' ? sticker.position : { x: 0, y: 0 }
  const size = typeof sticker?.size === 'object' ? sticker.size : { height: 70, width: 70 }
  const rotation = Number.isFinite(sticker?.rotation) ? sticker.rotation : 0

  return (
    <StickerGraphic
      src={option.src}
      alt={option.defaultLabel}
      height={size.height}
      width={size.width}
      x={position.x}
      y={position.y}
      rotation={rotation}
      zindex={sticker.zindex}
      data-testid="StickerGraphic"
    />
  )
}
